import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsTransportation, MCAuthoritiesEventsTransportationUtils, MCCustomFunctionsParams } from "@maslul/common-services";
import { SelectItem } from "primeng/api";
import { Observable } from "rxjs";
import { MICustomFunctionsParams } from "../../../../models/fields/custom-function-params";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsTransportation extends MCAuthoritiesEventsTransportation {

    private authoritiesEventsTransportationUtils = inject(MCAuthoritiesEventsTransportationUtils);

    override getModelYear(customFunctionsObj: MCCustomFunctionsParams): Observable<Array<SelectItem>> {
        return this.authoritiesEventsTransportationUtils.getModelYear(customFunctionsObj, true);
    }

    transportCustomItem(customFunctionsObj: MICustomFunctionsParams) {
        const customItemObj = customFunctionsObj?.formisForm?.model?.customItem;
        const transportCustomItemValue = customItemObj?.transportCustomItem;
        if (customItemObj) {
            customItemObj.customItem = transportCustomItemValue?.value
                ? transportCustomItemValue
                : { value: transportCustomItemValue, label: transportCustomItemValue } as SelectItem;
        }
    }
}
